var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a-modal",
        {
          attrs: {
            title:
              _vm.fileType === "image"
                ? _vm.language["common.pictureUpload"]
                : _vm.language["system.file.upload"],
            width: _vm.width,
            visible: _vm.visible,
            okText: this.$store.getters.language["common.okButton"],
            cancelText: _vm.language["common.cancel"]
          },
          on: { ok: _vm.ok, cancel: _vm.close }
        },
        [
          _c("j-upload", {
            attrs: {
              "file-type": _vm.fileType,
              beforeUpload: _vm.beforeUpload,
              uploadSource: _vm.uploadSource,
              newWindowOpen: _vm.newWindowOpen,
              value: _vm.filePath,
              disabled: _vm.disabled,
              maxSize: _vm.maxSize,
              number: _vm.number,
              multiple: _vm.multiple
            },
            on: { change: _vm.handleChange }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }